var _circle, _circle2, _circle3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoadingDots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 12,
    r: 0,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: 0.67,
    calcMode: "spline",
    dur: "1.5s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 0,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: 0.33,
    calcMode: "spline",
    dur: "1.5s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 12,
    r: 0,
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    begin: 0,
    calcMode: "spline",
    dur: "1.5s",
    keySplines: "0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8;0.2 0.2 0.4 0.8",
    repeatCount: "indefinite",
    values: "0;2;0;0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingDots);
export default __webpack_public_path__ + "static/media/loadingDots.907dc3f6da427d4daad642ae0c8755c3.svg";
export { ForwardRef as ReactComponent };